import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'irembogov-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'integration-management-portal';
}
